export enum LoggingLevel {
    debug = 0,
    info = 1,
    warn = 2,
    error = 3,
}
